import { useState } from "react";
import { useTranslation } from "react-i18next";
import UploadBase64 from "../../../components/Files/FileBase64";
import Icontrash from "../../../layout/others/icon_delete.svg";
import IconEdit from "../../../layout/others/icon_edit.svg";
import FileService from "../../../services/FileService";
import { usePrecandidateContext } from "../context/Context";
import ModalCreatePrecandidate from "../create/ModalCreatePrecandidate";
import ModalError from "../error/ModalError";
import { ReactComponent as IconDownload } from "../../../layout/others/icon_file.svg";
import DownloadIcon from "../../../layout/left_menu_icons/import.svg";
import "./style.scss";

export default function MassImport() {
  const [fileResult, setFileResult] = useState([]);
  const [editingIndex, setEditingIndex] = useState();
  const {
    modalErrorOpen,
    closeModalError,
    setModalShow,
    setPrecandidate
  } = usePrecandidateContext();
  const { t } = useTranslation();

  function deleteCv(index) {
    let _fileresult = [...fileResult];
    _fileresult.splice(index, 1);
    setFileResult(_fileresult);
  }

  async function openFile(file) {
    let base64res = await fetch(`data:${file.mimeType};base64,${file.base64}`);
    base64res.blob().then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("target", "_blank");
      document.body.append(link);
      link.click();
      link.parentNode.removeChild(link);
    });
  }
  function parseCv(filebase64) {
    FileService.uploadBase64(filebase64, "vitae/file/Multiparse").then(
      (data) => {
        if (!data.error)
          setFileResult(
            data.map((result) => {
              return {
                ...result,
                fileBase64: filebase64.filter(
                  (fileBase) => fileBase.fileName === result.fileName
                )
              };
            })
          );
      }
    );
  }
  function openEdit(index) {
    let fileResultPrecandidate = { ...fileResult[index] };
    setPrecandidate(fileResultPrecandidate);
    setEditingIndex(index);
    setModalShow(true);
  }
  
  function setMassImportPrecandidate(createdPrecandidate) {
    let fileresultCopy = [...fileResult];
    fileresultCopy[editingIndex].fileName = createdPrecandidate.fileName;
    fileresultCopy[editingIndex].fullName = createdPrecandidate.fullName;
    fileresultCopy[editingIndex].emailAddress = createdPrecandidate.emailAddress;
    fileresultCopy[editingIndex].phoneNumber = createdPrecandidate.phoneNumber;
    fileresultCopy[editingIndex].status = "Submitted";

    setFileResult(fileresultCopy);
  }

  return (
    <>
      <header className="page-header">
        <div className="header-title">
          <div className="title">
            <img src={DownloadIcon} alt="pc-icon" />
            <h1 style={{marginTop:"10px"}}>{t("Import Files")}</h1>
          </div>
          <div className="subtitle">
            {t("Recruitment/Pre-Candidates/Import")}
          </div>
        </div>
      </header>
      <div className="col-sm-4 mt-2 center-import-file">
        <UploadBase64
          multiple={true}
          afterLoadCallback={parseCv}
          accept="application/pdf, application/msword, application/xml, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      </div>
      <div className="table-wrapper">
        <table>
          <thead>
            <th>{t("Filename")}</th>
            <th>{t("Name")}</th>
            <th>{t("Email Address")}</th>
            <th>{t("Mobile number")}</th>
            <th>{t("Status")}</th>
            <th>{t("Actions")}</th>
          </thead>
          <tbody>
            {fileResult.map((file, index) => (
              <tr key={index}>
                <td>
                  <div>
                    <button
                      onClick={() => openFile(file.fileBase64)}
                      className="action-button"
                    >
                      <IconDownload />
                    </button>
                    {file.fileBase64.fileName}
                  </div>
                </td>
                <td>{file.fullName}</td>
                <td>{file.emailAddress}</td>
                <td>{file.phoneNumber}</td>
                <td>{t(file.status)}</td>
                <td>
                  {" "}
                  <button
                    href="#1"
                    className="action-button"
                    onClick={() => {
                      deleteCv(index);
                    }}
                    title={t("Delete")}
                    data-bs-toggle="tooltip"
                  >
                    <img
                      src={Icontrash}
                      alt="ico-ppl"
                      height="12px"
                      width="auto"
                    />{" "}
                  </button>
                  <button
                    href="#1"
                    className="action-button"
                    onClick={() => {
                      openEdit(index);
                    }}
                    title={t("Edit")}
                    data-bs-toggle="tooltip"
                  >
                    <img
                      src={IconEdit}
                      alt="ico-ppl"
                      height="12px"
                      width="auto"
                    />{" "}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <ModalCreatePrecandidate
        setMassImportPrecandidate={setMassImportPrecandidate}
      />
      <ModalError
        modalErrorOpen={modalErrorOpen}
        closeModalError={closeModalError}
        setModalShow={setModalShow}
        setModalEditShow={setMassImportPrecandidate}
      />
    </>
  );
}
